import React from 'react';
import './App.css';
import SideNav from './SideNav';
import { HashRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import Home from './Home';
import About from './About';
import WhosWho from './WhosWho';
import Programmes from './Programmes';
import AdviceServices from './AdviceServices';
import Afterschools from './Afterschools';
import BulrushNursery from './BulrushNursery';
import EducationTraining from './EducationTraining';
import SeniorCitizens from './SeniorCitizens';
import PastoralCare from './PastoralCare';
import Famous from './Famous';
import RoomHire from './RoomHire';
import Events from './Events';
import News from './News';
import Contact from './Contact';



const programmeSublinks = [
  { label: 'Advice Services', path: '/advice' },
  { label: 'Afterschools', path: '/afterschools' },
  { label: 'Bulrush Nursery', path: '/nursery' },
  { label: 'Education and Training', path: '/education' },
  { label: 'Senior Citizens', path: '/seniors' },
  { label: 'Pastoral Care', path: '/pastoral' },
];

const mainLinks = [
  { label: 'Home', path: '/' },
  { label: 'About Us', path: '/about' },
  { label: "Who's Who", path: '/whoswho' },
  { label: 'Programmes', path: '/programmes', sublinks: programmeSublinks },
  { label: 'Famous Faces', path: '/famous' },
  { label: 'Room Hire', path: '/roomhire' },
  { label: 'Contact Us', path: '/contact' },
];



function App() {
  return (
    <Router>
      <div className="App" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', flex: 1, minHeight: '100vh', alignItems: 'stretch' }}>
          <SideNav />
          <main className="main-content" style={{ flex: 1, marginLeft: 0, paddingLeft: 0 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/whoswho" element={<WhosWho />} />
              <Route path="/programmes" element={<Programmes />} />
              <Route path="/advice-services" element={<AdviceServices />} />
              <Route path="/afterschools" element={<Afterschools />} />
              <Route path="/bulrush-nursery" element={<BulrushNursery />} />
              <Route path="/education-training" element={<EducationTraining />} />
              <Route path="/senior-citizens" element={<SeniorCitizens />} />
              <Route path="/pastoral-care" element={<PastoralCare />} />
              <Route path="/famous" element={<Famous />} />
              <Route path="/roomhire" element={<RoomHire />} />
              <Route path="/events" element={<Events />} />
              <Route path="/news" element={<News />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
        </div>
        <footer className="site-footer">
          <div className="footer-inner">
            <div>
              <strong>The Vine Centre</strong> &copy; {new Date().getFullYear()}<br />
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
  }
  export default App;
